import { CommunicationProvider, useCommunication } from "@/lib/CommunicationWrapper"
import { useEffect, useState } from "react";
import { CheckCircle2 } from "lucide-react";

const SuccessPageContent = () => {
    const [subscriptionActivated, setSubscriptionActivated] = useState(false);

    const messageListener = (event: MessageEvent) => {
        console.log("messageListener", event);
        if (event.data.type === "SUBSCRIPTION_ACTIVATED") {
            setSubscriptionActivated(true);
        } else if (event.data.type === "SUBSCRIPTION_NOT_ACTIVATED") {
            // Still waiting...
            console.log("Subscription not activated yet, waiting...");
        }
    }

    useEffect(() => {
        window.addEventListener('message', messageListener);
        return () => {
            window.removeEventListener('message', messageListener);
        }
    }, []);


    return (
        <div className="flex flex-col h-full overflow-y-auto items-center justify-center min-h-screen bg-gradient-to-b from-orange-50/30 via-white to-white">
            <div className="px-10 pt-8 pb-12 text-center max-w-2xl mx-auto">


                {/* Status Message */}
                {subscriptionActivated ? (
                    <div className="space-y-6">
                        <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-100 text-green-700 rounded-full text-sm font-semibold">
                            <CheckCircle2 className="size-4" />
                            <span>Activated!</span>
                        </div>
                        <p className="text-sm text-gray-500">
                            You can close this page now.
                        </p>
                    </div>
                ) : (
                    <div className="space-y-4">
                        <div className="flex items-center justify-center gap-3">
                            <span className="w-5 h-5 border-3 border-orange-500 border-t-transparent rounded-full animate-spin" />
                            <span className="text-gray-700 text-lg font-medium">Activating...</span>
                        </div>
                        <p className="text-sm text-gray-500">
                            This should only take a moment
                        </p>
                    </div>
                )}
            </div>
        </div>
    )
}

export const SuccessPage = () => {
    return (
        <SuccessPageContent />
    )
}